export default {
    data() {
        return {
            currentPage: 1,
            elementsPerPage: 20,
            ascending: false,
            sortColumn: '',
            leadsList: [],
            columns: ['SNo', 'Name', 'Email', 'PhoneNumber', 'RegnDate', 'RegnTime', 'InitialPurchaseDate', 'Promo']
        }
    },

    created() {
    },

    computed: {
        getbrokerLeads() {
            return this.$store.state.home.leads.leadsGenerated;
        }

    },


    methods: {
        sortTable: function sortTable(col) {
            if (this.sortColumn === col) {
                this.ascending = !this.ascending;
            } else {
                this.ascending = true;
                this.sortColumn = col;
            }

            var ascending = this.ascending;

            this.getbrokerLeads.sort(function (a, b) {
                if (a[col] > b[col]) {
                    return ascending ? 1 : -1
                } else if (a[col] < b[col]) {
                    return ascending ? -1 : 1
                }
                return 0;
            })
        },

        num_pages: function num_pages() {
            if (this.getbrokerLeads != undefined) { 
                return Math.ceil(this.getbrokerLeads.length);
            }
        },

        get_rows: function get_rows() {
            if (this.getbrokerLeads != undefined) {
                var start = (this.currentPage - 1) * this.elementsPerPage;
                var end = start + this.elementsPerPage;
                return this.getbrokerLeads.slice(start, end);
            }
        },

        change_page: function change_page(page) {
            this.currentPage = page;
        },

    }
}


// WEBPACK FOOTER //
// ./src/assets/js/PartnerBrokerLeads.js